import React from 'react';
import "../styles/app.scss";
import Symbols from './symbols/Symbols';
function App() {
  return (
    <div className="app">
      <Symbols />
    </div>
  );
}

export default App;
